import React from 'react';
import ProgramsAndTuitionTabs from '@/components/ProgramsAndTuitionTabs';
import ScrollReveal from '@/components/ScrollReveal';
import EnrollmentProcess from '@/components/EnrollmentProcess';

const Program = () => {
  return (
    <div className="pt-24 pb-16">
      <ScrollReveal>
        <ProgramsAndTuitionTabs />
      </ScrollReveal>
      <ScrollReveal delay={0.1}>
        <EnrollmentProcess />
      </ScrollReveal>
    </div>
  );
};

export default Program;
